// src/components/RepoCombobox.tsx
import type { ReactElement } from 'react';
import { ORG_REPOS } from '../data/orgRepos';

// Repo entry for the new-job form (A1EE-338). A native <datalist>-backed
// autocomplete over the static org-repo list (Task 10) with free-text allowed —
// the value is whatever the user types, normalized + validated by the form on
// submit (lib/repo.ts). Built in-house (no new dep). Labelled "Repo".
export function RepoCombobox({
  id,
  value,
  onChange,
  error,
  required = true,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  // Repo is required for prompt jobs but optional for interactive sessions
  // (the server defaults it), so the required `*` is caller-controlled.
  required?: boolean;
}): ReactElement {
  const listId = `${id}-options`;
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-sm font-medium text-slate-700">
        Repo{required && <span className="text-red-600"> *</span>}
      </label>
      <input
        id={id}
        type="text"
        role="combobox"
        aria-expanded="false"
        aria-controls={listId}
        list={listId}
        value={value}
        placeholder="attentive-mobile/code"
        aria-invalid={error ? 'true' : undefined}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded border border-slate-300 px-2 py-1.5 text-sm text-slate-900 focus:border-slate-400 focus:outline-none aria-[invalid=true]:border-red-400"
      />
      <datalist id={listId} data-testid="repo-options">
        {ORG_REPOS.map((r) => (
          <option key={r} value={r} />
        ))}
      </datalist>
      {error && (
        <p role="alert" className="mt-1 text-xs text-red-700">
          {error}
        </p>
      )}
    </div>
  );
}
